module.exports = __webpack_public_path__ + "img/enigma.7226a46e.jpg";